"use client";
import { Button } from "@/components/ui/button";
import TrendingUpIcon from "@heroicons/react/24/solid/ArrowTrendingUpIcon";
import ChatBubbleLeftRightIcon from "@heroicons/react/24/solid/ChatBubbleLeftRightIcon";
import StarIcon from "@heroicons/react/24/solid/StarIcon";
import { useSite } from "@/lib/hooks/site";
import { useState } from "react";
import VenueCardNoImg from "@/components/views/list/card/VenueCardNoImg";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";

export default function BeInTop() {
  const site: any = useSite();
  const { t } = useTranslation()
  const [error, setError] = useState(false);
  const getDomain = () => {
    const split = site.domain.split(".");
    return split[split.length - 1];
  };

  const heroSecondPhoto = site.setting?.design?.addVenue?.hero?.secondPhoto?.["1"]

  return (
    <div className="w-full lg:mt-[60px] py-[40px] bg-gray-secondary flex justify-center">
      <div className="container flex gap-6 lg:flex-row flex-col items-center">
        <div className="flex flex-col gap-6 lg:h-[508px] md:justify-between">
          <div className="flex flex-col gap-6">
            <h2 className="text-primary font-bold text-[32px]">
              {t("add-venue-page-third-section-title", {
                defaultValue: `${site.descriptions[0]?.title}.${getDomain()} ile Google’da en üstte olun!`
              })}
            </h2>

            <p className="text-assistant text-sm lg:text-base text-left font-bold">
              {t("add-venue-page-third-section-description", {
                defaultValue: `Google’da ${site.descriptions[0]?.title} ile ilgili aramalarda
              ${site.domain} en üstlerde yer alıyor ve ziyaretçiler bu sayede
              işletmenize ve kampanyalarınıza kolayca erişebiliyor.`
              })}
            </p>

            <div className="flex flex-wrap gap-4">
              <div className="shadow text-assistant rounded-full bg-white !py-1 px-2 flex gap-2 items-center font-medium text-xs">
                <StarIcon className="size-5 text-secondary" />

                <h3>Semtinizin yıldızı olun</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <TrendingUpIcon className="size-6 text-secondary" />

                <h3>En üste çıkın!</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <ChatBubbleLeftRightIcon className="size-6 text-secondary" />

                <h3>Müşterilerinizle iletişime geçin</h3>
              </div>
            </div>
          </div>

          <Button
            onClick={() => {
              window.scrollTo({
                top: 0,
              });
            }}
            className="bg-[#15BBAE] w-[143px] hover:bg-[#15BBAE] flex"
          >
            {t("venue-add-title")}
          </Button>
        </div>
        {!heroSecondPhoto || error ? (
          <div className="rounded-[24px] h-[377px] md:h-full w-[366] md:w-[506px]">
            <VenueCardNoImg type={0} />
          </div>
        ) : (
          <S3Image
            sizes="(max-width: 600px) 366px,
                  506px"
            src={`site/${site.id}/assets/${heroSecondPhoto}`}
            width={0}
            height={0}
            className="rounded-[24px] h-full max-md:h-[377px] w-[366px] md:w-[506px] object-cover object-center"
            alt={`${site.descriptions[0]?.title} ~ ${t("venue-add-title", { defaultValue: "Mekan Ekle" })}`}
            onError={() => setError(true)}
          />
        )}
      </div>
    </div>
  );
}
